import {
	Insights as InsightsIcon,
	KeyboardDoubleArrowRight as KeyboardDoubleArrowRightIcon,
	Lock as LockIcon,
} from '@mui/icons-material'

import { Tooltip } from '@mui/material'

import { renderAIFeatures } from '../../services/utils'

const ConversationInsightsSidebar = ({
	enterprise,
	insightLines,
	initialMessagesLoading,
	conversationAnalytics,
	renderedMessages,
	onClose,
}) => {
	return (
		<aside className="scout-panel scout-panel--sidebar">
			<div className="scout-panel__heading">
				<h2>
					<InsightsIcon />
					Insights com IA
				</h2>
				<Tooltip title="Recolher">
					<button
						type="button"
						className="scout-icon-button"
						onClick={onClose}
					>
						<KeyboardDoubleArrowRightIcon />
					</button>
				</Tooltip>
			</div>

			{renderAIFeatures(enterprise)
				? (insightLines.length ? (
					<ul className="scout-insights-list">
						{insightLines.map((line) => (
							<li key={line}>{line}</li>
						))}
					</ul>
				) : (
					<div className="scout-panel__empty">
						Não disponível.
					</div>
				))
				: (
					<div className="scout-panel__empty">
						Recurso indisponível no seu plano.
					</div>
				)
			}

			{initialMessagesLoading
				? <div className="scout-insights-meta scout-insights-meta--loading">
					<div>
						<span>Mensagens</span>
						<strong className="scout-loading-line scout-loading-line--value" />
					</div>
					<div>
						<span>Sentimento</span>
						<strong className="scout-loading-line scout-loading-line--value" />
					</div>
				</div>
				: <div className="scout-insights-meta">
					<div>
						<span>Mensagens</span>
						<strong>{conversationAnalytics?.messages || renderedMessages.length || 0}</strong>
					</div>
					<div>
						<span>Sentimento</span>
						{renderAIFeatures(enterprise)
							? <strong>
								{typeof conversationAnalytics?.sentiment === 'number' && conversationAnalytics.sentiment >= 0
									? conversationAnalytics.sentiment.toFixed(1)
									: 'N/D'}
							</strong>
							: <LockIcon />
						}
					</div>
				</div>
			}

			{conversationAnalytics?.products?.length ? (
				<div className="scout-chip-list">
					{conversationAnalytics.products.map((product) => (
						<span key={product} className="scout-chip">{product}</span>
					))}
				</div>
			) : null}
		</aside>
	)
}

export default ConversationInsightsSidebar